import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getNewsData = (state: IRootState) => state.news.data;
export const getNewsFilterOption = (state: IRootState) => state.news.filterOption;
export const getNewsSort = (state: IRootState) => state.news.sort;
export const getNewsPage = (state: IRootState) => state.news.page;
export const getNewsAnnounce = (state: IRootState) => state.news.announce;
